import type { RedoMerchantRpcClient } from "@redotech/merchant-sdk-client/client";
import { createRedoMerchantRpcClient } from "@redotech/merchant-sdk-client/client";
import { Context, createContext, ReactNode, useMemo } from "react";
import { clientVersionHeaders } from "./client-version-headers";

export const RedoMerchantRpcClientContext: Context<
  RedoMerchantRpcClient | undefined
> = createContext<RedoMerchantRpcClient | undefined>(undefined);
RedoMerchantRpcClientContext.displayName = "RedoMerchantRpcClientContext";

export function RedoMerchantRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const redoMerchantRpcClient = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoMerchantRpcClient({
      baseURL: new URL(`${baseUrl}/rpc`),
      headers: { ...clientVersionHeaders, Authorization: authToken },
    });
  }, [baseUrl, authToken]);
  return (
    <RedoMerchantRpcClientContext.Provider value={redoMerchantRpcClient}>
      {children}
    </RedoMerchantRpcClientContext.Provider>
  );
}
